
export default function ProdunitQuote() {
  return (
    <>
    <div className="produnit-quote">
        <div className="container">
            <div className="row align-items-center">  

                <div className="col-lg-7 col-md-7">
                    <div className="prodquote-box">
                        {/* <img src="/image/quote.webp" loading="lazy" alt="quote"/>
                        <p>At Saysha Interior, we see design as a partnership between imagination and craftsmanship. Every piece we create is built with care, combining modern design thinking with skilled manufacturing.</p> */}

                        <h2 className="heading">End-to-End Manufacturing Facilities</h2>
                        <div>
                            <ul>
                                <li>1. Stock yard</li>
                                <li>2. Cold press 10’x4’</li>
                                <li>3. Advanced cutter machines</li>
                                <li>4. CNC</li>
                                <li>5. Pin router</li>
                                <li>6. Throughfit edgebanding</li>
                                <li>7. Multi boring</li>
                            </ul>
                            <ul>
                                <li>8. Paint booth</li>
                                <li>9. Aluminium section</li>
                                <li>10. Upholstery section</li>
                                <li>11. Metal work fabrication</li>
                                <li>12. Stone fabrication</li>
                                <li>13. Carpenter section</li>
                                <li>14. Assembling and packaging unit</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="col-lg-5 col-md-5">
                    <img src="/image/production-quote.webp" className="img-responsive radius-8 wow animate__animated animate__fadeInRight" data-wow-duration="1.1s" data-wow-delay="0.3s" loading="lazy" alt="production"/>
                </div>

            </div>
        </div>
    </div>
    </>
  )
}
